import {usePathname} from "next/navigation";

export const useRedirectToCurrentPage = (href: string) => {
	const pathname = usePathname();
	return `${href}?redirect=${pathname}`;
};
